// Regras do arquivo importado (CNH, RG, CRLV...) que a tela guarda até salvar o cadastro. Funções puras.
//
// A importação é { arquivo, guardar, referencia }:
//  - arquivo: o File escolhido pelo usuário;
//  - guardar: se o usuário quer manter o arquivo nos documentos do cadastro;
//  - referencia: o CPF (pessoa) ou a placa (veículo) lido no documento. Serve para não anexar o documento a um
//    cadastro que não é o dele (por exemplo, se o usuário trocar a placa depois de importar).

// Compara CPF/CNPJ e placa ignorando pontos, hífens e maiúsculas
export const normalizarReferencia = (valor) => String(valor || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

// Tamanho máximo de um documento guardado no cadastro. Igual ao arquivo.upload.max-size do backend: mantido baixo porque
// os arquivos entram no backup e contam no armazenamento do plano web.
export const TAMANHO_MAXIMO_ANEXO_MB = 3;

export const excedeLimiteDeAnexo = (arquivo) => !!arquivo && arquivo.size > TAMANHO_MAXIMO_ANEXO_MB * 1024 * 1024;

// Arquivo que deve ser anexado ao cadastro quando a tela salvar (ou null se não há, se o usuário desmarcou ou se o
// arquivo passa do limite, caso em que o servidor o recusaria)
export const arquivoParaAnexar = (importacao) =>
  (importacao && importacao.guardar && !excedeLimiteDeAnexo(importacao.arquivo) ? importacao.arquivo : null);

// Decide se o arquivo importado pode ser anexado ao cadastro que acabou de ser salvo.
// referenciaSalva: CPF/CNPJ (pessoa) ou placa (veículo) do cadastro salvo.
// Devolve { arquivo, divergente }: divergente=true quando o documento é de outro CPF/placa e por isso NÃO deve ser anexado.
export function resolverAnexo(importacao, referenciaSalva) {
  const arquivo = arquivoParaAnexar(importacao);
  if (!arquivo) return { arquivo: null, divergente: false };
  const lida = normalizarReferencia(importacao.referencia);
  const salva = normalizarReferencia(referenciaSalva);
  if (lida && salva && lida !== salva) return { arquivo: null, divergente: true };
  return { arquivo, divergente: false };
}
